"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDisplayAttributesFromLink = void 0;

const description_maker_1 = __importDefault(require("./description_maker"));

const metadata_maker_1 = __importDefault(require("./metadata_maker"));

const embed_code_maker_1 = __importDefault(require("./embed_code_maker"));

const link_helpers_1 = require("./link_helpers");

const provider_name_maker_1 = __importDefault(require("./provider_name_maker"));

const thumbnail_maker_1 = __importDefault(require("./thumbnail_maker"));

const title_maker_1 = __importDefault(require("./title_maker"));

function buildDisplayAttributesFromLink(link, options) {
  const attrs = {};
  attrs.url = link.url;
  attrs.content_category = link.content_category || 'unknown';
  attrs.content_subcategory = link.content_subcategory || '';
  attrs.extension = link.extension || '';
  attrs.title = title_maker_1.default(link);
  attrs.description = description_maker_1.default(link);
  attrs.metadata = metadata_maker_1.default(link);
  const image = thumbnail_maker_1.default(link, options);
  attrs.image_url = image.url;
  attrs.image_width = image.width;
  attrs.image_height = image.height;
  attrs.image_color = image.color;
  attrs.image_aspect_ratio = image.aspect_ratio;
  attrs.image_luminance = image.luminance;
  attrs.embed_code = embed_code_maker_1.default(link, image, options);
  attrs.show_meta = !!attrs.title;
  attrs.is_tiny = image.width < 100 && image.height < 100;
  attrs.is_downloadable = link_helpers_1.isStatic(link);
  attrs.is_fallback = !link.preview_image || !link.preview_image.url;
  attrs.is_transparent = link.preview_image && link.preview_image.is_transparent || false;
  attrs.provider_name = provider_name_maker_1.default(link);
  return attrs;
}

exports.buildDisplayAttributesFromLink = buildDisplayAttributesFromLink;